import { useQuery } from '@tanstack/react-query';
import { promotionPoliciesApi } from '~/lib/api/client';
import { tokenToForm } from '~/lib/mappers/promotion';
import { DEMO_POLICY } from '~/lib/fixtures/demo-policy';
import { emptyPromotionForm, type PromotionFormValues } from '~/lib/schemas/promotion';

export const promotionKeys = {
	all: ['promotions'] as const,
	list: (params: unknown) => ['promotions', 'list', params] as const,
	detail: (id: string | number) => ['promotions', 'detail', String(id)] as const
};

/**
 * Fetches a single policy and maps it into the form shape. `id="demo"` returns
 * the canonical fixture (dev/QA affordance) without hitting the backend.
 */
export function usePromotion(id: string | number) {
	return useQuery<PromotionFormValues>({
		queryKey: promotionKeys.detail(id),
		queryFn: async () => {
			if (id === 'demo') return DEMO_POLICY;
			if (id === 'new') return emptyPromotionForm();
			const res = await promotionPoliciesApi.getById(Number(id));
			return tokenToForm(res.data);
		}
	});
}
